import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';

import { useChatsNotificationsMicrofrontend } from './hooks';

export const ChatsNotificationsContainer = () => {
  const manifest = useChatsNotificationsMicrofrontend();

  if (!manifest) {
    return null;
  }

  return (
    <Microfrontend
      name={manifest.microfrontendName}
      runtime={manifest.runtimeName}
      image={manifest.imageVersion}
      instance={manifest.instanceId}
    />
  );
};
